/**
 * seoConfig.ts
 * SEO configuration for the MathBoard application
 */

export const seoConfig = {
  // Site information
  site: {
    name: "Math Whiteboard",
    url: import.meta.env.VITE_APP_URL || "https://themathboard.com",
    description:
      "Interactive board for live classroom lessons and solo AI-tutor math practice",
    author: "Math Whiteboard Team",
    email: "mathboard16@gmail.com",
  },

  // Default meta tags
  meta: {
    title: "Free Online Math Whiteboard for Teachers & Students | MathBoard",
    description:
      "Free online math whiteboard for teachers and students. Teach a live class or practice with an AI coach — a math board for teaching and solo study, with no download.",
    keywords:
      "math whiteboard, mathwhiteboard, math board, maths whiteboard, math whiteboard online, online whiteboard for math, math board for teaching, free online whiteboard for teaching math, AI practice coach",
    image: "/og-image.png",
    twitterHandle: "@mathboard",
  },

  // Social media
  /*social: {
    facebook: "https://www.facebook.com/mathboard",
    twitter: "https://twitter.com/mathboard",
    linkedin: "https://www.linkedin.com/company/mathboard",
    youtube: "https://www.youtube.com/@mathboard",
  },*/

  // Analytics
  analytics: {
    googleAnalyticsId: "G-5TXR2KXWS2",
    conversionTrackingId: "AW-18006829563",
  },

  // Sitemap
  sitemap: {
    baseUrl: import.meta.env.VITE_APP_URL || "https://themathboard.com",
    updateFrequency: "weekly",
    defaultPriority: 0.5,
  },

  // Robots
  robots: {
    userAgent: "*",
    allow: ["/", "/practice", "/he/practice"],
    disallow: ["/admin", "/private", "/api/", "/dist/", "/build/"],
    crawlDelay: 1,
  },

  // Performance
  performance: {
    enableCompression: true,
    enableCaching: true,
    cacheMaxAge: 86400, // 24 hours
  },

  // Structured Data
  organization: {
    name: "MathBoard",
    url: "https://themathboard.com",
    logo: "https://themathboard.com/logo.png",
    email: "mathboard16@gmail.com",
    /*sameAs: [
      "https://www.facebook.com/mathboard",
      "https://www.twitter.com/mathboard",
      "https://www.linkedin.com/company/mathboard",
    ],*/
  },

  // Breadcrumbs
  breadcrumbs: {
    enabled: true,
    separator: " > ",
  },

  // Open Graph
  openGraph: {
    type: "website",
    locale: "en_US",
  },

  // Search engines
  searchEngines: {
    googleVerification: import.meta.env.VITE_GOOGLE_SITE_VERIFICATION,
    bingVerification: import.meta.env.VITE_BING_SITE_VERIFICATION,
  },
};

export default seoConfig;
